const processCardsArr = document.querySelectorAll('.process-card');
